import React from 'react'
import { Link } from 'react-router-dom'
import 'css/components/return-to-dashboard.css'

export const ReturnToDashboard = () => {
    return (
        <div className="return-to-dashboard-container">
            <Link to="/dashboard" className="return-to-dashboard-link">
                <span className="return-to-dashboard-ico" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
                </span>
                Return to teacher dashboard
            </Link>
        </div>
    )
}